import profileimg from "../../Images/blank.jpg";
import verifiedres from "../../Images/Verify responsive.png";
import verified from "../../Images/verified.png";
import StarRatings from "react-star-ratings";
import { useNavigate } from "react-router-dom";
import ProfileActionPop from "./ContactProfileAction";

export default function ProfileCard({ contact, reloadContactList }) {
    const navigate = useNavigate();

    const openBox = (item) => {
        navigate("/profile/" + item?.userName?.trim())
    };

    const handleReloadContactList = () => {
        if (reloadContactList) {
            reloadContactList();
        }
    }

    return (
        <div className="contact-card" key={contact?.nonmemberDetails?._id}>
            <div
                className="brdrblckdiv"
                key={contact?.nonmemberDetails?._id}
                style={{ cursor: "pointer" }}
            >
                <div className="cntntflx">
                    <div
                        onClick={() => openBox(contact?.nonmemberDetails)}
                        style={{ width: "100%" }}
                    >
                        <div className="cntcnmdtlsmai">
                            <div className="imgvrtdiv border">
                                <img
                                    src={
                                        contact?.nonmemberDetails?.profilePhoto || profileimg
                                    }
                                    alt="..."
                                />
                            </div>
                            <div className="dtghhnjkd">
                                <div className="responResFig">
                                    <span className="prdltxtflx">
                                        <p className="jhntxtlws">
                                            {contact?.nonmemberDetails?.personName}
                                        </p>
                                        <p className="mrttxtt">
                                            {contact?.nonmemberDetails?.designation}
                                        </p>
                                        {contact?.nonmemberDetails?.memberStatus ? (
                                            <figure className="contResFig">
                                                <img src={verifiedres} alt="Verified Badge" title="Verified Badge" />
                                            </figure>
                                        ) : (<i className="fa-solid fa-circle-exclamation text-danger fs-3 ml-1" style={{ fontSize: "19px" }} title="Unverified"></i>)}
                                    </span>
                                    {contact?.nonmemberDetails?.memberStatus ? (
                                        <div
                                            className="upbtndivmainlop"
                                            key={contact?.nonmemberDetails?._id}
                                        >
                                            <div className="vrdfbrdr">
                                                <span className="">Verified</span>
                                                <img src={verified} alt="..." />
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            className="upbtndivmainlop"
                                            key={contact?.nonmemberDetails?._id}
                                        >
                                            <div className="vrdfbrdr">
                                                <span className="">Unverified</span>
                                                <i
                                                    className="fa-solid fa-circle-exclamation text-danger fs-3 ml-1"
                                                    style={{ fontSize: "19px" }}
                                                ></i>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <span className="prdltxtflx wrapbox">
                                    <p className="cmpntyxt">
                                        {contact?.nonmemberDetails?.companyName}
                                    </p>
                                    <p className="dghttxt">
                                        {contact?.nonmemberDetails?.TypeOfCompany}
                                    </p>
                                </span>
                                <span className="prdltxtflx">
                                    {contact?.nonmemberDetails?.telephoneNo && (
                                        <p className="mbltxtop">
                                            <span>Tel:</span>{" "}
                                            {contact?.nonmemberDetails?.telephoneNo},
                                        </p>
                                    )}
                                    <p className="mbltxtop">
                                        {!contact?.nonmemberDetails
                                            ?.telephoneNo && (
                                                <span>Mobile:</span>
                                            )}{" "}
                                        {contact?.nonmemberDetails?.phone_code +
                                            " " +
                                            contact?.nonmemberDetails?.mobileNo}
                                    </p>

                                </span>
                                <p className="mbbjlisown">
                                    <span>
                                        {" "}
                                        {contact?.nonmemberDetails?.location}
                                    </span>{" "}
                                    {contact?.nonmemberDetails?.location && ","}
                                    <span>
                                        {" "}
                                        {contact?.nonmemberDetails?.emirate}
                                    </span>{" "}
                                    -
                                    <span>
                                        {" "}
                                        {contact?.nonmemberDetails?.country}
                                    </span>{" "}
                                </p>
                                <div className="lksflwresrt">
                                    <div className="txtljklppp">
                                        <span>Likes:</span>{" "}
                                        {contact?.nonmemberDetails?.likeCount}
                                    </div>
                                    <div className="txtljklppp">
                                        <span>Connections:</span> {contact?.nonmemberDetails?.memberCount}
                                    </div>
                                    <div className="">
                                        <StarRatings
                                            rating={
                                                contact?.nonmemberDetails?.avgRating
                                            }
                                            starRatedColor="#F3660B"
                                            starEmptyColor="grey"
                                            numberOfStars={5}
                                            name="UserProfileRating" // Set to a generic name for product ratings
                                            starDimension="18px"
                                            starSpacing="2px"
                                            className="fa-regular fa-star"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ProfileActionPop key={contact?.nonmemberDetails?._id} contact={contact} reloadList={handleReloadContactList} />
                </div>
            </div>
        </div>
    );
}
